var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59 81",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.919 28.885l-8.005 7.448-7.428-14.982 3.844-8.617c1-1.749 2.559-1.729 3.534 0z",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.487 21.35l7.428 14.982L0 64.161z",
    fill: "#f57f17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.674 17.501c1.43-1.375 2.909-.905 3.286 1.042l7.787 45.247-25.811 15.495c-.9.5-3.299.715-3.299.715s-2.184-.26-3.016-.75L0 64.161z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.488 21.35L.003 64.16 10.017 1.594c.37-1.949 1.48-2.137 2.469-.417z",
    fill: "#ffa000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFirebase);
export default __webpack_public_path__ + "static/media/google-firebase.cb23de82f122ec20588a741fe1c720b3.svg";
export { ForwardRef as ReactComponent };